<template>
  <div :class="['cb-number-container',{'cb-number-group__append':$slots.append}]">
      <div class="cb-number-prepend" >
          <slot name="prepend"></slot>
      </div>
      <div :class="{'cb-number__append':$slots.append}" style="width:100%">
          <ElInputNumber v-model="_value"
                    autocomplete="new-password"
                    :rounding="rounding"
                    :step="step"
                    :min="min"
                    :max="max"
                    :label="label"
                    :step-strictly="stepStrictly"
                    :precision="precision"
                    :size="size"
                    :disabled="disabled"
                    :controls="controls"
                    @change="changeNumber"
                    @blur="blurChange"
                    @focus="$emit('focus',$event)"
                    :controls-position="controlsPosition"
                    :name="name"
                    :placeholder="placeholder"></ElInputNumber>
      </div>
   <div class="cb-number-suffix" >

         <slot name="suffix"></slot>
   </div>
      <!-- 后置元素 -->
    <div class="el-input-group__append" v-if="$slots.append">
        <slot name="append"></slot>
    </div>
  </div>
</template>

<script>
import { number } from 'echarts';
import ElInputNumber from './ElNumber.vue'
export default {
    components:{
      ElInputNumber,
    },
    props:{
        step: {
        type: Number,
        default: 1
      },
      stepStrictly: {
        type: Boolean,
        default: false
      },
      max: {
        type: Number,
        default: Infinity
      },
      min: {
        type: Number,
        default: -Infinity
      },
      value: {},
      disabled: Boolean,
      size: String,
      controls: {
        type: Boolean,
        default: false
      },
      controlsPosition: {
        type: String,
        default: 'right'
      },
      name: String,
      label: String,
      placeholder: String,
      precision: {
        type: Number,
        validator(val) {
          return val >= 0 && val === parseInt(val, 10);
        }
      },
      rounding:{//是否四舍五入
          type:Boolean,
          default:true
      }
    },
    computed:{
        _value:{
            get(){
                if(this.value===""||this.value===null||this.value===undefined ){
                  return undefined;
                }
                return this.value;
            },
            set(val){
                this.$emit('input',val)
            }
        }
    },
      data() {
          return {

          }
      },
      methods: {
       calcIconOffset(place) {
        let elList = [].slice.call(this.$el.querySelectorAll(`.cb-number-${place}`) || []);
        if (!elList.length) return;
        let el = null;
        for (let i = 0; i < elList.length; i++) {
          if (elList[i].parentNode === this.$el) {
            el = elList[i];
            break;
          }
        }
        if (!el) return;
        const pendantMap = {
          suffix: 'append',
          prefix: 'prepend'
        };

        const pendant = pendantMap[place];
        if (this.$slots[pendant]) {
          el.style.transform = `translateX(${place === 'suffix' ? '-' : ''}${this.$el.querySelector(`.cb-number-${pendant}`).offsetWidth}px)`;
        } else {
          el.removeAttribute('style');
        }
      },
      changeNumber(event){
        this.$emit("change",event)
      },
      blurChange(event){
        this.$emit("blur",event)
      },
       updateIconOffset() {
        // this.calcIconOffset('prefix');
        // this.calcIconOffset('suffix');
      },
      },
      //生命周期 - 创建完成
     created(){

     },

     //DOM挂载完毕
    mounted() {
      this.updateIconOffset();
    },
    updated() {
      this.$nextTick(this.updateIconOffset);
    }
}

</script>
<style lang='less' scoped>
.cb-number-container{
    width: 100%;
    display: flex;
    position: relative;
    .cb-number-prepend {
      position: absolute;
      height: 100%;
      left: 3px;
      text-align: center;
      color: #c0c4cc;
      transition: all .3s;
      pointer-events: none;
      display: flex;
      align-items: center;
      z-index: 99;
    }

    .cb-number-suffix{
        position: absolute;
        height: 100%;
        right: 8px;
        top: 0;
        text-align: center;
        color: #c0c4cc;
        transition: all .3s;
        pointer-events: none;
        display: flex;
        align-items: center;
    }
    /deep/ .el-input-number{
        width: 100%;
        .el-input input{
            text-align: left;
        }
    }
    .cb-number__append{
        /deep/ .el-input input{
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
        }
    }
  // /deep/.el-input.is-disabled .el-input__inner{
  //   background-color:#FFFFFF;
  //   color:#606266
  // }
  /deep/ .el-input-number .el-input-number__increase,
  /deep/ .el-input-number .el-input-number__decrease{
    opacity: 0;
    width: 24px;
  }
  /deep/ .el-input-number.is-controls-right .el-input__inner{
    padding-left: 15px;
    padding-right: 38px;
  }
  /deep/ .el-input-number.is-controls-right:hover{
     .el-input-number__increase,.el-input-number__decrease{
       opacity: 1;
     }
  }
}
.cb-number-group__append{
    line-height: normal;
    display: inline-table;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/cloud-clinic/components/CbNumber.vue